<div class="modal fade" bsModal #modalKonfirmasiSave="bs-modal" tabindex="-1" aria-labelledby="modalKonfirmasiSave"
  aria-hidden="true" id="modalKonfirmasiSave" role="dialog" [config]="{backdrop: 'static', keyboard: false}">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="card-header d-flex">
        <h5 class="mr-auto">Pengaturan</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="aplikasiForm" style="width: 100% !important;">
          <div class="divider">
            <span class="divider-text">Aplikasi</span>
          </div>
          <div class="row mt-1 mb-2">
            <label class="col-sm-4 col-form-label">Tahun Anggaran</label>
            <div class="col-sm-8">
              <select class="form-control" formControlName="tahunAnggaran">
                <option *ngFor="let year of yearList" value="{{year}}">{{year}}</option>
              </select>
            </div>
          </div>
        </form>
        <div class="row mt-1 mb-2">
          <label class="col-sm-4 col-form-label"></label>
          <div class="col-sm-8">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="tahunAnggaranPreviousStatus" (change)="onCheckboxChange()">
              <label class="form-check-label">Tampilkan Tahun Anggaran Sebelum {{ tahunAnggaran }}</label>
            </div>
          </div>
        </div>
        <form [formGroup]="penggunaForm" style="width: 100% !important;">`
          <div class="divider">
            <span class="divider-text">Pengguna</span>
          </div>
          <div class="row mt-1 mb-2">
            <label class="col-sm-4 col-form-label" for="nrk">NRK:</label>
            <div class="col-sm-8">
              <input readonly class="form-control" id="nrk" type="text" formControlName="nrk">
            </div>
          </div>
          <div class="row mt-1 mb-2">
            <label class="col-sm-4 col-form-label" for="nama">Nama:</label>
            <div class="col-sm-8">
              <input readonly class="form-control" id="nama" type="text" formControlName="nama">
            </div>
          </div>
          <div class="row mt-1 mb-2">
            <label class="col-sm-4 col-form-label" for="nip">NIP:</label>
            <div class="col-sm-8">
              <input readonly class="form-control" id="nip" type="text" formControlName="nip">
            </div>
          </div>
          <div class="row mt-1 mb-2">
            <label class="col-sm-4 col-form-label" for="jabatan">Jabatan:</label>
            <div class="col-sm-8">
              <input readonly class="form-control" id="jabatan" type="text" formControlName="jabatan">
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-center">
        <button ngbTooltip="Batal" data-placement="bottom" class="btn btn-circle btn-danger" data-dismiss="modal" *ngIf="(tahunAnggaran === null || tahunAnggaran === undefined || tahunAnggaran === '')"
          [routerLink]="['/', tahunAnggaran,'login']"><i class="icon-logout"></i></button>
        <button ngbTooltip="Batal" data-placement="bottom" class="btn btn-circle btn-danger" data-dismiss="modal" *ngIf="(tahunAnggaran !== null && tahunAnggaran !== undefined && tahunAnggaran !== '')"
          [disabled]="(tahunAnggaran === null || tahunAnggaran === undefined || tahunAnggaran === '')"
          (click)="modal.hide()"><i class="fa fa-close "></i></button>
        <button type="button" ngbTooltip="Simpan" data-placement="bottom" class="btn btn-circle btn-primary"
          data-dismiss="modal" (click)="saveTahunAnggaran()"><i class="fa fa-save"></i></button>
      </div>
    </div>
  </div>
</div>
